module.exports = __webpack_public_path__ + "img/change-location.8cf9188f.svg";